import { FieldProps, InputValue, Select, SelectProps } from '@optimus-web/core';
import { ControllerProps, useControllerWithEventHandler } from '../hooks';

export type FormSelectFieldProps = Omit<FieldProps & SelectProps, 'selected' | 'onBlur' | 'error'> &
    ControllerProps<NonNullable<SelectProps['selected']>> & {
        onSearchChange?: (searchValue: string) => void;
        disableInputSearch?: boolean;
        searchPlaceholder?: React.ReactNode;
        value?: InputValue;
    };

export const FormSelectField = ({
    defaultValue,
    name,
    onChange,
    rules,
    shouldUnregister,
    transform,
    ...other
}: FormSelectFieldProps) => {
    const { value, error, handleChange, onBlur, context } = useControllerWithEventHandler({
        defaultValue,
        name,
        onChange,
        rules,
        shouldUnregister,
        transform,
    });

    const displayedValue = other.multiselect && value == null ? [] : value;
    const props = {
        ...other,
        error,
        name,
        onBlur,
        onChange: handleChange,
        selected: displayedValue,
        value: displayedValue,
        readOnly: context?.readOnly || other.readOnly,
    };

    return <Select {...props} />;
};
